import { createReducer, on } from '@ngrx/store';

import { NewAirResultsResponse, AirMobileResults } from '@app/entities/flight-results';
import * as actions from '@flight-results/store/actions/flights-results.actions';
import { exchangeSearchAction } from '@user-history/store/actions/user-history.actions';

export const initialFlightResultsMobileState: NewAirResultsResponse = {Results: {AirResults: []}} as NewAirResultsResponse;

export const flightResultsMobileReducer = createReducer(
  initialFlightResultsMobileState,
  on(actions.fetchAirResultsSuccessAction, (state, { flightResults }) => {
    return {
      ...flightResults,
      Results: {
        ...flightResults.Results,
        AirResults: ((state?.Results as AirMobileResults)?.AirResults)
          .concat((flightResults?.Results as AirMobileResults)?.AirResults)
      }
    }
  }),
  on(
    actions.noResultsSearchFlightsAction,
    actions.clearFlightResultsAction,
    actions.saveFlightSearchData,
    actions.searchFlightsAction,
    exchangeSearchAction,
    () => initialFlightResultsMobileState
  ),
);
